<p style="text-align: center">
  <img alt="logo" src="../../../assets/lfw-logo-default.png" title="LiveFORMS-Web" />
</p>
<p style="text-align: center">{{ longVersion }}</p>
<br /><br />
<p style="text-align: center; color: yellow">{{ errorText }}</p>
<br /><br />
<p style="text-align: center">
  <button mat-button (click)="goBack()" matTooltip="{{ showToolTip() ? ('DIALOGS.BACK' | translate) : '' }}">
    <mat-icon>arrow_back</mat-icon> {{ 'DIALOGS.BACK' | translate }}
  </button>
</p>
